import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_OptDischargeSummary = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_OptDischargeSummary' className='file-pdf-document'>
            <div className='file-template'>
                <h2>Amethyst Consulting & Treatment Solutions, PLLC
                </h2>
                <h3>Discharge/Transition Plan
                </h3>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Agency Admission Date:</span>
                        </td>
                        <td className='w-250'><span className='eleHeader'>Program Admission Date:</span>
                        </td>
                        <td className='w-250'><span className='eleHeader'>Program Discharge Date:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id="txtAgencyDate" name="txtAgencyDate" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id="txtProgramDate" name="txtProgramDate" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id="txtDischargeDate" name="txtDischargeDate" className='add-only' />
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Program Admission Type:</span> </td>
                        <td className='w-375'><span className='eleHeader'>Agency Discharge Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                        <input type='text' id="txtProgramAdmissionType" name="txtProgramAdmissionType" className='add-only' defaultValue='OPT' />
                        </td>
                        <td className='w-375'>
                            <input type='date' id="txtAgencyDisDate" name="txtAgencyDisDate" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Type of Transition:</span>
                        </td>
                    </tr>
                    <tr><td className='w-375'>
                            <input type="checkbox" id="cbTypeTransition_1" name="cbTypeTransition_1" className='add-only' value="3" /> Planned program discharge
                        </td>
                        
                        <td className='w-375'>
                            <input type="checkbox" id="cbTypeTransition_2" name="cbTypeTransition_2" className='add-only' value="2" /> Geographic relocation
                        </td>
                    </tr> 
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTypeTransition_3" name="cbTypeTransition_3" className='add-only' value="1" /> Significant change in the intensity or level of treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTypeTransition_4" name="cbTypeTransition_4" className='add-only' value="4" /> Other : &nbsp;
                            <input type="text" id="txtTypeTransition" name="txtTypeTransition" className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Services to Support Patient with Transition:
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbServiceTrans_1" name="cbServiceTrans_1" className='add-only' value="1" /> Outpatient Therapy
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" id="cbServiceTrans_2" name="cbServiceTrans_2" className='add-only' value="2" /> Adjustment/Transition Counseling
                        </td>
                       
                    </tr>
                    <tr>
                         <td className='w-750'>
                            <input type="checkbox" id="cbServiceTrans_3" name="cbServiceTrans_3" className='add-only' value="3" /> Other: N/A
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Community Resource Referrals:
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCommunityReferral_1" name="cbCommunityReferral_1" className='add-only' value="1" /> Housing
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCommunityReferral_2" name="cbCommunityReferral_2" className='add-only' value="2" /> Employment
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCommunityReferral_3" name="cbCommunityReferral_3" className='add-only' value="3" /> Financial
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCommunityReferral_4" name="cbCommunityReferral_4" className='add-only' value="4" /> Transportation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCommunityReferral_5" name="cbCommunityReferral_5" className='add-only' value="5" /> Medical
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCommunityReferral_6" name="cbCommunityReferral_6" className='add-only' value="6" /> Psychological
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCommunityReferral_7" name="cbCommunityReferral_7" className='add-only' value="7" /> Recovery Support
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbCommunityReferral_8" name="cbCommunityReferral_8" className='add-only' value="8" />
                            Other: N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Presenting Condition
                    </span>
                    <span className='small'>(According to the "Presenting Condition" section of the Mental Health Assessment that was
                        completed upon admission)
                    </span>
                    <textarea id="txtPresentingCondition" name="txtPresentingCondition" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Progress toward recovery or well-being
                    </span>
                    <span className='small'>(This is based on a review of functioning at admission, the participant`s identified needs and goals, the level of goal achievement, and the level of functioning at discharge as compared to the level of functioning at
                        admission)
                    </span>
                    <textarea id="txtProgressWellbeing" name="txtProgressWellbeing" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Gains achieved during program participation
                    </span>
                    <span className='small'>(How did the participant`s life improve during program participation)
                    </span>
                    <textarea id="txtGainParticipate" name="txtGainParticipate" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths, Needs, Abilities, Preferences
                    </span>
                    <span className='small'>(Review this section of the Mental Health Assessment and compare to the participants functioning at discharge. What changes have occurred in these areas as a result of program participation?)
                    </span>
                    <textarea id="txtStrengthsPrefer" name="txtStrengthsPrefer" className='add-only'></textarea>
                </p>
                <h4>Current Medications (prescribed and non-prescribed):</h4>
                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Type</span></td>
                        <td className='w-100'><span className='eleHeader'>Strength</span></td>
                        <td className='w-100'><span className='eleHeader'>Dosage</span></td>
                        <td className='w-100'><span className='eleHeader'>Side Effects</span></td>
                        <td className='w-250'><span className='eleHeader'>Benefits</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id="txtType_1" name="txtType_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtStrength_1" name="txtStrength_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDosage_1" name="txtDosage_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtSideEffects_1" name="txtSideEffects_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtType_1" name="txtBenefits_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id="txtType_2" name="txtType_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtStrength_2" name="txtStrength_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDosage_2" name="txtDosage_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtSideEffects_2" name="txtSideEffects_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtType_2" name="txtBenefits_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id="txtType_3" name="txtType_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtStrength_3" name="txtStrength_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDosage_3" name="txtDosage_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtSideEffects_3" name="txtSideEffects_3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtType_3" name="txtBenefits_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id="txtType_4" name="txtType_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtStrength_4" name="txtStrength_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtDosage_4" name="txtDosage_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtSideEffects_4" name="txtSideEffects_4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtType_4" name="txtBenefits_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Persons providing input used in the development of this plan:
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='small'>(check all that apply)
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Patient : &nbsp;
                            <input type="checkbox" id="cbPatient_1" name="cbPatient_1" className='add-only' value="1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>Family Member : 
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbFamilyMemb_1" name="cbFamilyMemb_1" className='add-only' value="1" /> Spouse/Partner
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbFamilyMemb_2" name="cbFamilyMemb_2" className='add-only' value="2" /> Parent
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbFamilyMemb_3" name="cbFamilyMemb_3" className='add-only' value="3" /> Children
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>Clinic Staff : 
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbClinicStaff_1" name="cbClinicStaff_1" className='add-only' value="1" /> Counselor
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbClinicStaff_2" name="cbClinicStaff_2" className='add-only' value="2" /> Program Director
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbClinicStaff_3" name="cbClinicStaff_3" className='add-only' value="3" /> Program Staff
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>&nbsp;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbClinicStaff_4" name="cbClinicStaff_4" className='add-only' value="4" /> Physician
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbClinicStaff_5" name="cbClinicStaff_5" className='add-only' value="5" /> Other : 
                            <input type='text' id="txtClinicStaff" name="txtClinicStaff" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Original Referral Source:
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>Legal System : 
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOriginalReferral_1" name="cbOriginalReferral_1" className='add-only' value="1" /> Probation Officer
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOriginalReferral_2" name="cbOriginalReferral_2" className='add-only' value="2" /> Parole Office
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOriginalReferral_3" name="cbOriginalReferral_3" className='add-only' value="3" /> Attorney
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>&nbsp;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOriginalReferral_4" name="cbOriginalReferral_4" className='add-only' value="4" /> Judge
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOriginalReferral_5" name="cbOriginalReferral_5" className='add-only' value="5" /> Other:
                            <input type='text' id="txtOriginalReferral" name="txtOriginalReferral" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>Friend/Social Support : 
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSocialSupport_1" name="cbSocialSupport_1" className='add-only' value="1" /> Roommate
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSocialSupport_2" name="cbSocialSupport_2" className='add-only' value="2" /> Co-Worker
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSocialSupport_3" name="cbSocialSupport_3" className='add-only' value="3" /> Friend
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>&nbsp;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSocialSupport_4" name="cbSocialSupport_4" className='add-only' value="4" /> Other : Self
                        </td>
                        <td className='w-187'>&nbsp;
                        </td>
                        <td className='w-187'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>Other : 
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOther_1" name="cbOther_1" className='add-only' value="1" /> Employer
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOther_2" name="cbOther_2" className='add-only' value="2" /> Potential Employer
                        </td>
                        <td className='w-187'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Support systems needed to assist and support the patient in his/her process of continuing recovery/wellbeing:
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSupportSystem_1" name="cbSupportSystem_1" className='add-only' value="1" /> Housing : &nbsp;
                            <input type='text' id="txtSupportSystem_1" name="txtSupportSystem_1" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSupportSystem_2" name="cbSupportSystem_2" className='add-only' value="2" /> Employment : &nbsp;
                            <input type='text' id="txtSupportSystem_2" name="txtSupportSystem_2" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSupportSystem_3" name="cbSupportSystem_3" className='add-only' value="3" /> Social/Leisure : &nbsp;
                            <input type='text' id="txtSupportSystem_3" name="txtSupportSystem_3" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSupportSystem_4" name="cbSupportSystem_4" className='add-only' value="4" /> Family : &nbsp;
                            <input type='text' id="txtSupportSystem_4" name="txtSupportSystem_4" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSupportSystem_5" name="cbSupportSystem_5" className='add-only' value="5" /> Financial : &nbsp;
                            <input type='text' id="txtSupportSystem_5" name="txtSupportSystem_5" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSupportSystem_6" name="cbSupportSystem_6" className='add-only' value="6" /> Church : &nbsp;
                            <input type='text' id="txtSupportSystem_6" name="txtSupportSystem_6" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSupportSystem_7" name="cbSupportSystem_7" className='add-only' value="7" /> Recovery Groups : &nbsp;
                            <input type='text' id="txtSupportSystem_7" name="txtSupportSystem_7" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSupportSystem_8" name="cbSupportSystem_8" className='add-only' value="8" /> Organized Community Groups/Activities : &nbsp;
                            <input type='text' id="txtSupportSystem_8" name="txtSupportSystem_8" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSupportSystem_9" name="cbSupportSystem_9" className='add-only' value="8" /> Other : &nbsp;
                            <input type='text' id="txtSupportSystem_9" name="txtSupportSystem_9" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                
                <p className='w-750'><h4>Referral source information (include contact name, address, phone #, days and hours of service if applicable):<br />
                    If applicable specific after care provider and the scheduled appointment(s) and any referral source</h4>
                </p>
                
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Agency Name and Address
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id="txtAgencyName" name="txtAgencyName" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Contact Person</span></td>
                        <td className='w-250'><span className='eleHeader'>Phone #</span></td>
                        <td className='w-250'><span className='eleHeader'>Day and Hours of Service</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txtContactPerson" name="txtContactPerson" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtPhoneNo" name="txtPhoneNo" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtDayHours" name="txtDayHours" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Date and Time of First Appointment (if applicable)
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='time' id="txtAppointmentTime" name="txtAppointmentTime" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='date' id="txtAppointmentDate" name="txtAppointmentDate" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Options available if significant relapse occurs or if additional services are needed:</strong><br />
                    If for any reason you are experiencing difficulty after your transition from this program and are not able get needed
                    assistance, please contact Amethyst Consulting & Treatment Solutions, PLLC at (336) 674-9781.
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Client Signature:
                        </td>
                        <td className='small w-250'>Date:
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Guardian Signature:
                        </td>
                        <td className='small w-250'>Date:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    My signature indicates I have participated in this plan and have been offered a copy of it
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Therapist Signature:
                        </td>
                        <td className='small w-250'>Date:
                        </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}  
